<template>

	<div class="main-contents">
		<div class="mem_container prj_sp">

			<div style="display: flex; width: 1200px; margin: 0 auto;">	
				<div class="contents-body demand tab flex mx-0">
					<ProjectInfo v-model="projectNm" :projectSeq="projectSeq" type="3" @goList="$router.go(-1)"  @prjSideInfo="setPrjSideInfo"/>
				</div>

				<div class="sticky-btn" style="height: 250px;">
					<div class="recruit" @click="goModifyProject()">					
						<div class="btn_blue">프로젝트 수정하기</div> 
					</div>

					<div class="deadline flex-col px-0 py-0">
						<div v-if="prjSideInfo.recrEndDateDiff >= 0">
							<span class="date">
								<img src="/images/tec/prj/date_color.png" alt="마감기간"/> 
								마감 <span class="period">{{prjSideInfo.recrEndDateDiff}}</span> 일 전
								<!-- 모집마감 -->
							</span>
						</div>
						<div>
							<span>
								<img src="/images/tec/prj/member_sm.png" alt="지원자수"/>
								지원 IT프로 <span class="member">{{prjSideInfo.appCount}}</span> 명
							</span>
						</div>
					</div>

					<div class="management mt-0"> 						
						<div class="manager">
							<span>
								담당 매니저 <strong>{{prjSideInfo.admMgrMberNm}}</strong>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="btn-prj-detail">
				<span class="btn-list" @click="$router.go(-1)">
					&lt; 목록보기
				</span>
			</div>
		</div>
	</div>

</template>

<script>

import ProjectInfo from '@/components/highpro/ProjectInfo.vue';

export default {

	components : {
		ProjectInfo
	},

	data() {
		return {
			projectSeq : 0,
			projectNm : '',
			prjSideInfo : {}
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
		if(this.$route.query.projectSeq != undefined && this.$route.query.projectSeq != '') {
			this.projectSeq = Number(this.$route.query.projectSeq);
		}		

	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		// 프로젝트정보
		setPrjSideInfo(prjSideData){
			this.prjSideInfo = prjSideData;
		},
		
		// 프로젝트 수정
		goModifyProject() {
            if(!this.$store.state.userInfo.mberSeq == this.prjSideInfo.corpMgrMberSeq) return;
			
            this.$router.push({name : 'PRJ303M03', query : {projectSeq : this.projectSeq}, params : {caller : { name : 'PRJ303M01'}}});
		},

		

	},
};
</script>
